<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-10 20:04 -->
<!-- Description:  -->
<template>
  <div>
    <h4>USUARIO: </h4>
    <div>
      <pre>{{ user }}</pre>
    </div>
    <h4>ROLES</h4>
    <UserRoles :key="id" :userId="id"></UserRoles>
    <h4>PERMISOS</h4>
    <UserPermissions :key="id" :userId="id"></UserPermissions>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";
import UserRoles from "../permissions/UserRoles.vue";
import UserPermissions from "../permissions/UserPermissions.vue";
// script content
export default {
  name: "UserPermissionView",
  components: {
    UserRoles,
    UserPermissions,
  },

  // directives

  props: {
    id: {}
  },

  data: () => ({
    user: {}
  }),

  computed: {
    //
  },

  // watch: {},

  async mounted() {
    let res = await AdminService.getUser(this.id);
    this.user = res;
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>

